import React, { useEffect, useState } from 'react';
import { Mail, Trash2, CheckCircle } from 'lucide-react';

const BulkLeads = () => {
  const [leads, setLeads] = useState([]);

  useEffect(() => {
    fetch('https://wethrift-backend.onrender.com/api/bulk/all')
      .then(res => res.json())
      .then(data => setLeads(data));
  }, []);

  const sendEmail = (email, name) => {
    window.location.href = `mailto:${email}?subject=Wethrift Bulk Order Update for ${name}`;
  };

  return (
    <div className="p-6 bg-black min-h-screen text-white">
    {/* --- RESPONSIVE BULK ORDERS HEADER --- */}
<div className="mb-6 lg:mb-10 px-2 lg:px-0">
  <div className="flex flex-col items-start lg:items-start gap-1">
    
    {/* Heading with Cyberpunk underline on mobile */}
    <div className="relative inline-block">
      <h1 className="text-2xl sm:text-3xl lg:text-5xl font-black italic uppercase tracking-tighter leading-none">
        Bulk_Orders<span className="text-emerald-500 lg:text-white lg:opacity-100">_Dashboard</span>
      </h1>
      {/* Mobile-only accent line */}
      <div className="h-1 w-12 bg-emerald-500 mt-2 lg:hidden rounded-full" />
    </div>

    {/* Subtitle with decorative elements */}
    <div className="flex items-center gap-2 mt-2">
      <div className="hidden lg:block h-[1px] w-8 bg-emerald-500/50" />
      <p className="text-emerald-500 text-[9px] lg:text-xs font-black uppercase tracking-[0.2em] lg:tracking-[0.4em] flex items-center gap-2">
        <span className="inline-block w-1.5 h-1.5 bg-emerald-500 rounded-full animate-pulse lg:hidden" />
        B2B Wholesale Inquiries
      </p>
    </div>
  </div>
</div>

      <div className="grid gap-4">
        {leads.length === 0 ? (
           <div className="p-10 border border-dashed border-zinc-800 text-center text-zinc-500 rounded-3xl">No bulk requests yet.</div>
        ) : (
          leads.map((lead) => (
            <div key={lead._id} className="p-6 border border-zinc-800 bg-zinc-900/40 rounded-[2rem] flex flex-col md:flex-row justify-between items-start md:items-center gap-4 hover:border-emerald-500/50 transition-all">
              <div>
                <div className="flex items-center gap-3 mb-1">
                  <span className="text-[10px] bg-emerald-500 text-black px-2 py-0.5 rounded-full font-black uppercase italic">{lead.status}</span>
                  <h3 className="text-xl font-bold">{lead.business_name}</h3>
                </div>
                <p className="text-zinc-400 text-sm font-medium">{lead.email}</p>
                <div className="flex gap-4 mt-3">
                   <div className="text-[10px] uppercase font-bold text-zinc-500">Qty: <span className="text-white">{lead.quantity}</span></div>
                   <div className="text-[10px] uppercase font-bold text-zinc-500">Cat: <span className="text-white">{lead.category}</span></div>
                </div>
              </div>

              <button 
                onClick={() => sendEmail(lead.email, lead.business_name)}
                className="w-full md:w-auto bg-white text-black px-6 py-3 rounded-2xl font-black text-[10px] uppercase tracking-widest hover:bg-emerald-500 transition-colors flex items-center gap-2 justify-center"
              >
                <Mail size={14} /> Reply to Client
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default BulkLeads;